module.exports = __webpack_public_path__ + "img/icon1.0dac7685.svg";